import type { SVGProps } from "react";
const SvgNumber00 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    fillRule="evenodd"
    stroke="black"
    strokeWidth={0.501}
    strokeLinejoin="bevel"
    strokeMiterlimit={10}
    fontFamily="Times New Roman"
    fontSize={16}
    style={{
      fontVariantLigatures: "none",
    }}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    width="40.342pt"
    height="73.243pt"
    viewBox="35.769 -727.911 40.342 73.243"
    {...props}
  >
    <defs />
    <g id="Board Elements" transform="scale(1 -1)">
      <g
        id="Group"
        fillRule="nonzero"
        strokeLinejoin="round"
        strokeLinecap="round"
        stroke="none"
        strokeWidth={0.416}
      >
        <g id="Group_1">
          <g id="Group_2">
            <g id="Group_3" fill="#262626">
              <g id="Group_4">
                <path
                  d="M 55.178,654.876 C 50.039,654.196 45.776,655.182 42.391,657.833 C 39.006,660.484 36.973,664.379 36.292,669.518 C 36.208,670.152 36.129,671.239 36.054,672.779 L 35.77,701.986 C 35.733,708.114 37.422,713.276 40.837,717.472 C 44.251,721.668 48.814,724.144 54.524,724.899 C 59.663,725.579 63.923,724.61 67.304,721.991 C 70.686,719.371 72.716,715.492 73.397,710.353 C 73.59,708.894 73.674,707.775 73.648,706.997 L 73.932,677.79 C 73.977,671.599 72.29,666.421 68.871,662.256 C 65.453,658.092 60.888,655.632 55.178,654.876 Z M 55.089,668.712 C 56.167,668.855 57.02,669.484 57.647,670.6 C 58.274,671.716 58.605,673.115 58.64,674.799 L 58.294,705.934 C 58.316,706.26 58.284,706.74 58.2,707.374 C 58.032,708.643 57.646,709.609 57.042,710.271 C 56.438,710.934 55.66,711.202 54.708,711.076 C 53.566,710.925 52.682,710.292 52.055,709.176 C 51.428,708.06 51.128,706.665 51.157,704.99 L 51.408,673.842 C 51.378,673.58 51.401,673.163 51.476,672.592 C 51.644,671.323 52.05,670.328 52.695,669.606 C 53.339,668.884 54.137,668.586 55.089,668.712 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
            <g id="Group_5" fill="#f7e5c5">
              <g id="Group_6">
                <path
                  d="M 57.356,657.678 C 52.217,656.998 47.954,657.984 44.569,660.635 C 41.184,663.286 39.151,667.181 38.47,672.32 C 38.386,672.954 38.307,674.041 38.232,675.581 L 37.948,704.788 C 37.911,710.916 39.6,716.078 43.015,720.274 C 46.429,724.47 50.992,726.946 56.702,727.701 C 61.841,728.381 66.101,727.412 69.482,724.793 C 72.864,722.173 74.894,718.294 75.575,713.155 C 75.768,711.696 75.852,710.577 75.826,709.799 L 76.11,680.592 C 76.155,674.401 74.468,669.223 71.049,665.058 C 67.631,660.894 63.066,658.434 57.356,657.678 Z M 57.267,671.514 C 58.345,671.657 59.198,672.286 59.825,673.402 C 60.452,674.518 60.783,675.917 60.818,677.601 L 60.472,708.736 C 60.494,709.062 60.462,709.542 60.378,710.176 C 60.21,711.445 59.824,712.411 59.22,713.073 C 58.616,713.736 57.838,714.004 56.886,713.878 C 55.744,713.727 54.86,713.094 54.233,711.978 C 53.606,710.862 53.306,709.467 53.335,707.792 L 53.586,676.644 C 53.556,676.382 53.579,675.965 53.654,675.394 C 53.822,674.125 54.228,673.13 54.873,672.408 C 55.517,671.686 56.315,671.388 57.267,671.514 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default SvgNumber00;
